import { request } from '../request'

export function getSettlementPay(data) {
  return request({
    url: '/award/statement/initPay',
    method: 'POST',
    data
  })
}
//费用条目列表
export function getItemList(data) {
  return request({
    url: '/settlement/item/list',
    method: 'get',
    params: data
  })
}
